import { UserRole } from 'constant'

const getCurrentUserRole = (): string | null => {
  try {
    const userStr = localStorage.getItem('user')
    if (!userStr) return null
    const user = JSON.parse(userStr)
    return user?.role ?? null
  } catch (e) {
    return null
  }
}

const hasRole = (role: string) => getCurrentUserRole() === role
const hasAnyRole = (roles: string[]) => {
  const current = getCurrentUserRole()
  return current ? roles.includes(current) : false
}

const isAdmin = () => hasRole(UserRole.Admin.value)

const isWarehouseSO = () => hasRole(UserRole.WarehouseSO.value)

const isWarehouseM = () => hasRole(UserRole.WarehouseM.value)

const isWarehouseTOPO = () => hasRole(UserRole.WarehouseTOPO.value)

const isWarehouseChina = () => hasRole(UserRole.WarehouseChina.value)

export {
  getCurrentUserRole,
  hasRole,
  hasAnyRole,
  isAdmin,
  isWarehouseSO,
  isWarehouseM,
  isWarehouseTOPO,
  isWarehouseChina
}
